import logo from './logo.svg';
import './App.css';
import  Todolist from "../src/componens/todolist"
// import Todo from "./componens/todo"
import {Todocontext} from "./context/todoscontext"
import { v4 as uuidv4 } from 'uuid';
import { useState } from 'react';
import Mysnackbar from "./componens/snakpar"
import {Toastcontext} from "./context/toastcontext"


const inisinaltodos=[
  {
    id:uuidv4(),
    tittle:"قراعه كتاب ",
    detals:"kjkhklhkl",
    iscomplet:false,
  },
  {
    id:uuidv4(),
    tittle:"قراعه كتاب ",
    detals:"kjkhklhkl",
    iscomplet:false,
  },
  {
    id:uuidv4(),
    tittle:"قراعه كتاب ",
    detals:"kjkhklhkl",
    iscomplet:false,
  },
]

function App() {
  const[todos,settodos]=useState(inisinaltodos);
  const [open, setOpen] = useState(false);//snackparجايه من حق 
  const [maasge, setmaasge] = useState();
  // داله حق اضهار الرساله حق الااضافه وتعديل والحذف
   function Showhidetoast(maasge){
    setOpen(true);//تبدا النافذه
    setmaasge(maasge)//رساله الذي تم الاضافه
    setTimeout(() => {//وقت النافذه 
      setOpen(false)//متى الوقت الذي تشتي تغلقها
    }, 2000);//دقيقتين
 }
  return (
    <Toastcontext.Provider value={{Showhidetoast}}>
  < div
   style={{
    backgroundColor:"gray",
    display:"flex",
    justifyContent:"center",
    alignItems:"center",
    height:"100vh",
    direction:"rtl"
    }}
    >
      <Mysnackbar open={open} maasge={maasge} /> {/* maasge الرساله الذيي عيقلك انه تم الااضافه او تم الحذف او تم التعديل*/}
      <Todocontext.Provider value={{todos, settodos}}>
        <Todolist/>
      </Todocontext.Provider>
    
  
  </div>
     
      
       
  </Toastcontext.Provider>
  );
  
}

export default App;
